var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.8643C14.4873 18.8643 18.125 15.2266 18.125 10.7393C18.125 6.25194 14.4873 2.61426 10 2.61426C5.51269 2.61426 1.875 6.25194 1.875 10.7393C1.875 15.2266 5.51269 18.8643 10 18.8643Z",
    fill: "#3073D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 9.8059L8.48338 6.98924C8.31996 6.89489 8.13458 6.84521 7.94588 6.84521C7.75717 6.84521 7.5718 6.89489 7.40838 6.98924C7.24481 7.08366 7.10924 7.21983 7.01554 7.38381C6.92184 7.54779 6.87335 7.73371 6.87504 7.92257V13.5559C6.87393 13.6974 6.90098 13.8377 6.95461 13.9686C7.00824 14.0995 7.08738 14.2185 7.18743 14.3185C7.28747 14.4186 7.40642 14.4977 7.53735 14.5513C7.66828 14.605 7.80856 14.632 7.95004 14.6309C8.13743 14.6333 8.32189 14.5843 8.48338 14.4892L13.4167 11.6726C13.5812 11.5785 13.718 11.4427 13.8131 11.2788C13.9082 11.1149 13.9583 10.9287 13.9583 10.7392C13.9583 10.5497 13.9082 10.3636 13.8131 10.1997C13.718 10.0358 13.5812 9.89993 13.4167 9.8059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLogo);
export default __webpack_public_path__ + "static/media/play-logo.78d1bbf3ec5157bfa0882793635d8494.svg";
export { ForwardRef as ReactComponent };